import classnames from 'classnames'
import PropTypes from 'prop-types'
import React from 'react'

import { chainDecorators, memoized } from '../../utils/ReactUtils'
import Image from '../../datas/models/Image'
import ImageGatsby from '../ImageGatsby'

import styles from './styles'


const decorators = [
  memoized,
]

function Person(props) {
  const { firstName, lastName, title, photo, color } = props

  return (
    <div className={classnames('container', color)}>
      <div className="photo">
        <ImageGatsby src={photo} />
      </div>
      <div className="name">
        <p className="personName">{`${firstName} ${lastName}`}</p>
        <p className="title">{`${title}`}</p>
      </div>
      <style jsx>{styles}</style>
    </div>
  )
}

Person.colors = {
  pink: 'pink',
  blue: 'blue',
  purple: 'purple',
  yellow: 'yellow',
}

Person.propTypes = {
  firstName: PropTypes.string.isRequired,
  lastName: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  photo: Image.propTypes.isRequired,
  color: PropTypes.oneOf(Object.values(Person.colors)).isRequired,
}


Person = chainDecorators(decorators, Person)

export default Person
